import { LOWER_THRESHOLD, UPPER_THRESHOLD } from "../constants/employment";

export const shouldShowSalaryNudge = (
  salary: number,
  isRexMonster: boolean,
) => {
  // If channel is not rexmonster (India), do not show the nudge
  if (!isRexMonster) {
    return false;
  }

  if (typeof salary !== "number" && isNaN(salary)) {
    return false;
  }

  // Check if the salary is within the defined thresholds
  return salary < LOWER_THRESHOLD || salary > UPPER_THRESHOLD;
};
